@let headerVisible = headerVisible$ | async;
@if (headerVisible) {
  <app-header></app-header>
}

<div class="bodyWrap" [class.no-header]="!headerVisible">
  <router-outlet></router-outlet> 
</div>

<app-global-loader></app-global-loader>
<app-share-via-email-modal></app-share-via-email-modal>
<app-toaster></app-toaster>


